// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__z246Q","title":"Info_title__aIMRH","links":"Info_links__18zsf","link":"Info_link__2VFDs","logo":"Info_logo__bLgyP"};